#     _    _                 _
#    / \  | |__   ___  _   _| |_
#   / _ \ | '_ \ / _ \| | | | __|
#  / ___ \| |_) | (_) | |_| | |_
# /_/   \_\_.__/ \___/ \__,_|\__|
#

about:
    heading: About
    aboutHtml: <span> <b>Product Name</b> <br />Enlivio </span> <br /> <br /> <span>
        <b>Manufacturer</b> <br /> room4 Softwareentwicklung GmbH <br /> Henneberggasse
        2-6, 1030 Wien, Österreich </span> <br /> <br /> <span> <b>Year of release</b> 2022
        </span> <br /> <span> <b>Current Release Version</b> {{version}} </span> <br />
        <br /> <a href="https://www.enlivio.com/intendeduse/" target="_blank" rel="noopener noreferrer">
        Intended use </a> <br /> <br /> <a href="https://room4physio.atlassian.net/servicedesk/customer/portal/3/group/4/create/26"
        target="_blank" rel="noopener noreferrer"> Report an incident </a>

#     _                             _
#    / \   ___ ___ ___  _   _ _ __ | |_
#   / _ \ / __/ __/ _ \| | | | '_ \| __|
#  / ___ \ (_| (_| (_) | |_| | | | | |_
# /_/   \_\___\___\___/ \__,_|_| |_|\__|
#

# components/MyAccountOverview
myAccountOverview:
    recommendationTitle: Recommend us
    referralSignupLink: Referral-link
    creditOverview: Credit overview
    creditText: Detailed usage information can be found in "training history"
    currentCredit: Credit balance
    myAccount: My Account
    buyCredits: Buy credits
    yourAccountData: Your account data
    patientContactOptionHeading: Contact options
    patientContactOptionBody: Patients can see your contact information in the mobile app in order to contact you. They will always see your email, but you can select if your phone number should be shown.
    patientContactOptionSwitch: Show phone number
    allowChatLabel: Allow patient to send me a personal chat message
    recommendationText:
        Schenke deinen Kolleg:innen und dir selbst <strong>5 Gratisstunden</strong>. Diese werden für dich
        freigeschaltet, sobald jemand auf deine Einladung hin die ersten fünf Videotherapiestunden gehalten hat. Teile
        dafür einfach deinen persönlichen Empfehlungslink.
    appointmentHeading: Appointment History
    appointmentPatient: Patient
    appointmentDate: Date
    appointmentStartTime: Start Time
    appointmentEndTime: End Time
    appointmentDuration: Duration
    tabAccount: My Account
    tabTrainingsHistory: Training History
    tabAppointmentHistory: Appointment History
    tabBillingLabel: Billing
    tabAvailability: Public Booking
    privacyPolicy: Privacy policy
    termsAndConditions: Terms and Conditions
    contractTitle: Privacy policy & Treatment contract
    contractDescription: Patients have to agree to your privacy policy and terms and conditions if they want to enter a therapy relationship with you.
    availability:
        title: Public Booking
        description: Patients who do not have a physiotherapist can book first meetings directly with you.
        aboutYou: About You
        aboutDescription: Patients will decide who to book based on the information about you.
        uploadImage: Change picture
        yourDescription: Your Description
        yourService: Your Service
        weeklyHours: Your weekly hours
        bookBefore: Book appointment before hours
        hourDropdown: 4,8,12,24,48,72
        hourLabel: hours
        days:
            mon: Monday
            tue: Tuesday
            wed: Wednesday
            thu: Thursday
            fri: Friday
            sat: Saturday
            sun: Sunday
        validation:
            aboutError: About yourself is required.
            noAvailability: At least one day availability is required.
            picRequired: Please provide your profile picture.
            specializationRequired: At least one specialization are required.
            invalidTime: Invalid time! Please make sure start time is always greater than end time.
            privacyPolicy: Privacy policy are required.
            termsAndCondition: Terms and conditions are required.

planDetails:
    currencySymbol: €
    planButton: Start Now
    confirmPlanTitle: Proceed to create profile
    confirmPlanBody: Your plan will start automatically on {planStartDate}.
    planConfirmButton: Finish
    planCancelButton: Cancel
    choosePlanLabel: Choose Your Plan
    currentPlan: Current Plan
    upgradePlanButton: Upgrade plan
    upgradeCancelButton: Cancel
    nextPaymentLabel: 'Price: {price} / month'
    planWillBeCanceled: You plan has been canceled and will not be renewed after {endDate}
    cancelSubscription: Cancel subscription
    upgradeModalTitle: Upgrade plan
    upgradeSuccessTitle: Plan Upgrade Successfully
    upgradeSuccessBody: You will be notified via email
    cancelModalTitle: Do you really want to cancel?
    cancelModalBody: If you cancel, your subscription will be cancelled by {endDate}. You will not be able to access your account anymore.
    cancelButton: Cancel subscription
    cancelSuccessTitle: Your plan has been canceled
    cancelSuccessBody: You will be notified via email

#     _       _           _
#    / \   __| |_ __ ___ (_)_ __
#   / _ \ / _` | '_ ` _ \| | '_ \
#  / ___ \ (_| | | | | | | | | | |
# /_/   \_\__,_|_| |_| |_|_|_| |_|
#

#containers/admin/Therapists
adminTherapistsContainer:
    buttons:
        refresh: Refresh
        refreshLoading: Loading...

#containers/Admin/AdminVideoList
adminVideoListContainer:
    buttons:
        refresh: Reset
        refreshWhileLoading: Refreshing...
        next: Next
        nextNoMore: No More

#containers/Admin/InsurancePlan
insurancePlanContainer:
    labels:
        planCode: Plan code
        planName: Plan name
        headerTitle: Header Title
        videoUrl: Video URL (optional)
        price: Price

#containers/Admin/QuestionsInsurancePlan
questionsInsurancePlanContainer:
    labels:
        selectPlan: Select Plan

#     _                      _       _                        _
#    / \   _ __  _ __   ___ (_)_ __ | |_ _ __ ___   ___ _ __ | |_
#   / _ \ | '_ \| '_ \ / _ \| | '_ \| __| '_ ` _ \ / _ \ '_ \| __|
#  / ___ \| |_) | |_) | (_) | | | | | |_| | | | | |  __/ | | | |_
# /_/   \_\ .__/| .__/ \___/|_|_| |_|\__|_| |_| |_|\___|_| |_|\__|
#         |_|   |_|

# components/sessions/CreateManualSessionForm
createManualSessions:
    labels:
        date: Treatment Date
        startTime: Treatment Start
        endTime: Treatment End
        submit: New "offline" treatment
    validation:
        date: Please enter the treatment date.
        startTime: Please enter the start of the treatment.
        endTime: Please enter the end of the treatment.
        startTimeEndTime: Treatment end must start after treatment start.
    modalTitle: Create an appointment
    deleteModal:
        title: Delete appointment
        body: Do you really want to delete the appointment?

# components/appointment/createAppointmentForm
createAppointmentForm:
    modalTitle: Create appointment
    labels:
        date: Date
        startTime: Start Time
        endTime: End Time
        submit: Create appointment
        selectDuration: Duration
        min: Min
        cancel: Cancel
        delete: Delete
        reject: Reject
        accept: Accept
        allTime: All
        availableTime: Available
        selectedTime: null
        selectedTimeAt: from
        bookedTooltip: Booked
        noAvailableTime: No available time slots
    validation:
        date: Please enter the appointment date.
        startTime: Please enter the start time.
        endTime: Please enter the end time.
        startTimeEndTime: The end time must be after the start time.
        pastDate: Date is in the past.
        pastTime: Time in the past.
        invalidDate: Invalid Date! correct date format is DD-MM-YYYY
    deleteModal:
        title: Delete appointment
        body: Do you really want to delete the appointment?
    acceptModal:
        title: Approve appointment
        body: Do you really want to approve the appointment?
    rejectModal:
        title: Reject appointment
        body: Do you really want to reject the appointment?
    appointmentStatus:
        pending: PENDING
        confirmed: CONFIRMED
        cancelled_by_therapist: CANCELLED
        cancelled_by_patient: CANCELLED
        rejected: REJECTED
        requested: CONFIRMED
        cancelled: CANCELLED
    fcmRoomCreatedTitle: Teletherapy started
    fcmRoomCreatedBody: Your therapist hast started the meeting
    fcmHostLeftTitle: Teletherapy end
    fcmHostLeftBody: Your therapist hast left the meeting
    noAppointmentData: No appointment found.
    fcmAppointmentReminderMin: 3
    fcmAppointmentReminderTitle: Appointment reminder
    fcmAppointmentReminderBody: Your therapy session with {first_name_of_therapist} is about to start. Join now!

# components/SessionList
sessionList:
    createButton: New "offline" treatment
    modalTitle: New "offline" treatment
    online: online
    offline: on-site

# components/ScheduleSession
scheduleSession:
    labels:
        inviteEmailAddress: E-Mail Patient
    placeholders:
        inviteMessage: Hi, you are invited to join an online physiotherapy session.

# containers/TherapyDetails
therapyDetails:
    appointments:
        title: Appointments
        button: New Appointment
        requestTitle: Appointment Request
    meetings:
        title: Course
    workouts:
        title: Training plan
    questionnaire:
        title: Questionnaire
    answerAndActivity:
        title: Questionnaire answers & Activity
    resendActivationEmail:
        button: Resend Activation E-Mail
        body: Patient has not activated their account yet. You can resend an activation email, which will be sent to <strong>{{email}}</strong>.
        successMsg: Activation email sent to {{email}} successfully.

#     _         _   _
#    / \  _   _| |_| |__
#   / _ \| | | | __| '_ \
#  / ___ \ |_| | |_| | | |
# /_/   \_\__,_|\__|_| |_|
#

# every localization string of auth0-lock is overridable
auth0lock:
    languageDictionary:
        loginSubmitLabel: Log-in
        loginWithLabel: Log-in with %s
        signUpTerms: With your sign-up, you are accepting our <a href="https://www.enlivio.com/wp-content/uploads/2021/11/AGB_Enlivio_B2B_v3_inclAVV_Physio.pdf" target="_blank">Terms & Conditions</a> and <a href="https://www.enlivio.com/wp-content/uploads/2021/11/20211027-heyData_Datenschutzerklärung-Website_DE_room4-Softwareentwicklung-GmbH_https___app.enlivio.com-1.pdf" target="_blank">Privacy Policy</a>
        emailInputPlaceholder: yourmail@provider.com
        passwordInputPlaceholder: Your password
        forgotPasswordTitle: Reset your password
        forgotPasswordAction: Forgot password?
        forgotPasswordInstructions: Please enter your email address. We will send you an email to reset your password.
        forgotPasswordSubmitLabel: Send email
        genericError: This user account exists already. Please use the login section and enter your user and password there. If you forgot your password, please use the password reset function.

loginBox:
    loginSubmitLabel: Log-in
    loginSubmitLabelLoading: Logging in

# accountSetup
accountSetup:
    heading: Just one more step to the account
    personalDetailLabel: Personal Data
    choosePlanLabel: Choose Your Plan
    therapistSubheading: Please add the following details
    gisaEntry: We check your "Gesundheitsberuferegister" entry to ensure the trustworthiness of our platform.
    notRegistered: Not registered as a physiotherapist in Austria?
    contactUs: Contact Us
    firstName: First Name
    lastName: Last Name
    street: Street, house number
    postal: Postcode
    city: City
    telephone: Telephone Number
    dateOfBirth: Date of Birth (DD MM YYYY)
    completeRegistration: Complete Registration
    firstNameRequired: Please enter your first name.
    lastNameRequired: Please enter your last name.
    pleaseFillIn: Please fill in.
    invalidPhone: Invalid telephone number. (No space allowed)
    ageValidation: Age should be in the range of 18 to 100.
    country: Country
    countryList: Austria,Germany,Switzerland
    choosePlan: Choose your plan
    yourPlan: Your Plan
    choosePlanLinkText: more info...
    choosePlanLink: https://www.enlivio.com/wp-content/uploads/2021/11/Einzelvertrag_StarterFree_v2.pdf

# components/loginSignup/LoginPageLayout
loginPage:
    welcome: Welcome to enlivio
    patients: Patients
    trainers: Therapists
    trainersSubheading: Sign up for free. Create your personal info page and get started with online teletherapy and group sessions with your patients.
    goToLogin: Login
    goToSignup: Create Account
    RegisteredAccount: Already have an account?
    noRegisteredAccount: Not yet registered?
    emailVerifiedBody: Your email has been confirmed.
    emailVerifedButton: Ok
    joinRoomHeading: Enter the code
    joinRoomDescription: Enter the code and go to physiotherapy with 1 click
    joinRoomButton: Enter room
    joinRoomSupport: >
        Something is wrong? <br />
        <a href="mailto:info@enlivio.com"> Contact our support! </a>
    joinRoomEmptyError: Please enter the room code!
    joinRoomLengthError: Please enter at least 4 characters for the room code

#   ____ _           _
#  / ___| |__   __ _| |_
# | |   | '_ \ / _` | __|
# | |___| | | | (_| | |_
#  \____|_| |_|\__,_|\__|
#

#components/chat/ChatComponents
chat:
    sendBtn: Send
    searchPlaceholder: Search
    typeMsgPlaceholder: Type your message
    offlineLabel: Offline
    onlineLabel: Online
    therapistNameLabel: You
    chatErrorTitle: Not Authorized
    chatErrorBody: You are not connected to start the chat!
    retryButtonText: Reconnect
    noPatientFound: No Patient Found
    noChatMessageFound: No Chat Message Found
    openPatientProfile: Open Patient Profile
    sendingFailed: Sending failed Click to retry!

#  _____
# | ____|_ __ _ __ ___  _ __
# |  _| | '__| '__/ _ \| '__|
# | |___| |  | | | (_) | |
# |_____|_|  |_|  \___/|_|
#

# Error Message templates
errorMessageTemplate:
    authError: Session Expired. Please login again!
    genericMsg: Some error occurred, Please try again!
    key_patientExists: User already exists
    key_noTherapistFound: No therapist found
    key_TherapyIDMissing: Therapy id is missing
    key_TherapyNotFound: Therapy not found
    key_DeletedSuccess: Deleted successfully
    key_WrongTherapy: Wrong therapist id.
    key_PatientNotFound: Patient not found
    key_FirstNameMissing: Firstname is missing
    key_LastNameMissing: Lastname is missing
    key_EmailMissing: Email is missing
    key_PatientProfileCheck: Patient profile check is missing
    key_NoProfileFound: No Profile Found
    key_InvalidAuth0AccountId: Invalid Auth0 AccountId
    key_Unauthorized: Unauthorized Access
    key_UnauthorizedTherapist: Unauthorized Therapist Request
    key_PasswordResetEmailSent: Password reset email sent
    key_UnauthorizedPatient: Unauthorized Patient Request
    key_OnBoardingFailed: On-boarding failed.
    key_AppointmentNotFound: Appointment not found
    key_DeleteAppointmentFailed: Could not delete appointment, Please try again.
    key_DeleteAppointmentSuccess: Appointment successfully deleted
    key_InvalidInputs: Please validate your inputs
    key_TrainingNotFound: Training plan not found
    key_NoMobileAccess: Mobile Access Not Allowed
    key_InvalidPatientLogin: Invalid Patient Login
    key_InvalidCredentials: Invalid Credentials
    key_TagNotFound: Tag Not Found
    key_NoAnswerFound: No Answer Found
    key_NoQuestionFound: No Questions Found
    key_RoomCodeNotFound: Could not find room code
    key_RoomCodeChangeNotAllowed: You are not allowed to change the room code
    key_RoomAlreadyFull: The room is already full - do you have your session already connected in another tab?
    key_RoomProvidePin: You need to provide PIN code for that room.
    key_RoomAlreadyParticipated: You already participated in that event.
    key_RoomParticipationCancelled: Your participation was cancelled.
    key_RoomWrongPin: Wrong ROOM PIN provided.
    key_RoomTrainerNotAllowed: Trainer not allowed to join that event.
    key_RoomNoSessionFound: Unable to find session with session ID with this room code
    key_ResetPatientPassword: Activation email sent to patients successfully
    key_profileUpdatedSuccess: Profile updated successfully
    key_TherapistMarkedAsTestUser: Therapist profile updated successfully
    key_TherapistPlanUpdatedSuccessful: Insurance plan updated successfully
    key_TemplateDeletedSuccssful: Template removed successfully
    key_TrainingTemplateSaved: Template saved successfully
    key_TrainingSavedAsDraft: Training plan saved as draft successfully
    key_TrainingSavedAsDraftFailed: Failed to save training plan, Please validate your inputs
    key_OnBoardingAnswerSavedSuccessfully: Answer saved successfully
    key_NotFound: Not found
    key_TherapistPlanUpgradeTitle: Upgrade your plan.
    key_TherapistPlanUpgradeError: Your plan only supports 2 patients. Please upgrade to the unlimited plan to create more patients.
    key_PatientLimitReached: Patient limit reached
    key_FeatureNotAllowed: Feature not enabled
    key_PlanCanceled: Plan cancelled successfully
    key_NoActivePlanFound: No active plan found
    key_PlanExpried: Plan Expired, Please login again to continue

#  _____                 _
# | ____|_   _____ _ __ | |_
# |  _| \ \ / / _ \ '_ \| __|
# | |___ \ V /  __/ | | | |_
# |_____| \_/ \___|_| |_|\__|
#

# Texts which are shown in the WordPress form after "Teilnehmen" has been clicked
events:
    subscribedResponseText:
        Vielen Dank für deine Anmeldung zu <b>{{eventName}}</b> mit {{trainerName}} am {{dayOfWeekDate}} von {{startTime}} Uhr bis {{endTime}} Uhr.
        <br/>
        Du erhältst eine E-Mail mit allen relevanten Informationen von uns. Bis bald!
    subscribedWaitingListResponseText:
        Vielen Dank für dein Interesse an <b>{{eventName}}</b> mit {{trainerName}} am {{dayOfWeekDate}} von {{startTime}} Uhr bis {{endTime}} Uhr.
        <br/>
        <b>Das Event ist leider schon voll.</b>
        <br/>
        Sollte noch ein Platz frei werden, erhältst du eine E-Mail mit allen relevanten Informationen. Bis bald!

# components/EventCard
eventCard:
    showDetails: Details
    publish: Publish
    cancel: Cancel
    enterRoom: Enter room
    minutes: '{{count}} minute'
    minutes_plural: '{{count}} minutes'

# components/EventDetails
eventDetails:
    columns:
        name: Name
        email: E-Mail
        isEmailConfirmed: E-Mail confirmed
        isOnlineParticipation: On/Offline Participation
        status: Status
        actions: Actions
        pin: PIN
    columnfilters:
        placeholder:
            name: Type Name...
            email: Type Email...
            isEmailConfirmed: Select Email-confirmed
            isOnlineParticipation: Select Participation
            status: Select Status
            pin: PIN-Code...
    isOnlineParticipation:
        true: online
        false: on-site
    isEmailConfirmed:
        true: yes
        false: no
    participants:
        header: Participants
        empty: no signed-up participants
    waitinglist:
        header: Waiting list
        empty: Waiting list empty
    notifications:
        resendEmail: The reminder has been sent.

# containers/Events/EventsContainer
eventsOverviewPage:
    heading: Group Rooms
    description: You can invite up to 20 participants into group rooms. Participants are joining a waiting room until you enter and open the room.
    createEvent: Create event
    draftEvents: Event-Drafts (non-published)
    publishedEvents: Published events
    inProgressEvents: Running events
    finishedEvents: Passed events
    canceledEvents: Cancelled events

# eventsContainer
eventsContainer:
    createEvent: Create events
    editEvent: Edit event
    deleteEvent: Delete event
    cancelEvent: Cancel event
    deleteEventQuestion: Do you really want to delete the event {{name}}?
    cancelEventQuestion: Do you really want to cancel the event {{name}}? Participants will be informed by Email.

# components/events/CreateEventForm
createEvent:
    labels:
        name: Event name
        description: Description
        date: Date
        startTime: Start time
        endTime: End time
        isOnline: Online event
        hasLocation: On-site event
        locationName: Place
        locationStreet: Street
        locationZip: ZIP
        locationCity: City
        locationCountry: Country
        locationDirections: How to get there
        costs: Ticket price
        maxParticipants: max. participants
        cancellationPeriod: Cancellation time in (h)
        createEvent: Create event
    validation:
        name: Enter event name.
        description: Enter event description.
        date: Enter event date.
        startTime: Enter event start time
        endTime: Enter event end time.
        startTimeEndTime: Start time has to lead end time.
        locationName: Please enter the place of the event.
        locationStreet: Please enter the street.
        locationZip: Please enter the ZIP code.
        locationCity: Please enter the city.
        locationCountry: Please enter the country.
        directions: Please enter the how to get there information.
        maxParticipants: Please enter the max. participants.
        cancellationPeriod: Please enter the allowed cancellation time in h.

eventStatus:
    DRAFT: Draft
    PUBLISHED: Published
    CANCELLED: cancelled
    IN_PROGRESS: in progress
    FINISHED: finished

subscriptionStatus:
    SUBSCRIBED: subscribed
    APPROVED: approved
    CANCELLED: cancelled
    PARTICIPATED: participated
    PAYED: paid
    JOINED: joined

#   ____                      _
#  / ___| ___ _ __   ___ _ __(_) ___
# | |  _ / _ \ '_ \ / _ \ '__| |/ __|
# | |_| |  __/ | | |  __/ |  | | (__
#  \____|\___|_| |_|\___|_|  |_|\___|
#

generic:
    cancel: Cancel
    delete: Delete
    close: Close
    save: Save
    edit: Edit
    copy: Copy
    pleaseChoose: Please choose
    back: Back
    archive: Archive
    approve: Approve
    reject: Reject
    loading: loading...
    teleTherapy: Teletherapie
    organizerName: Enlivio
    appointmentSubject: Enlivio Teletherapie Appointment
    therapistFeedback:
        link: https://room4physio.atlassian.net/servicedesk/customer/portal/3/group/4/create/23
        text: Feedback
    fileTooBig: You are most probably trying to upload a file larger than 1MB.
    uploadTitle: Upload Profile Picture
    chooseFileLabel: Click to, choose a file (Max 1MB size Allowed)
    uploadImageBtn: Select Image

#  _                    _ _
# | |    __ _ _ __   __| (_)_ __   __ _
# | |   / _` | '_ \ / _` | | '_ \ / _` |
# | |__| (_| | | | | (_| | | | | | (_| |
# |_____\__,_|_| |_|\__,_|_|_| |_|\__, |
#                                 |___/

# components/Landing
landing:
    enterCode: Enter code to join room
    enterCodePlaceholder: Enter code
    enterRoom: Join room
    signupNow: Sign up now
    title: Digital Physiotherapy - Online
    patientsTitle: For Patients
    trainersTitle: For Physiotherapists
    onlineTraining: >
        The online-platform, <br />
        to continue serve patients.
    codeveloped: Co-Developed by Physiotherapists
    signupAs: Sign up as Physiotherapists

#  _                     _
# | |    ___  __ _  __ _| |
# | |   / _ \/ _` |/ _` | |
# | |__|  __/ (_| | (_| | |
# |_____\___|\__, |\__,_|_|
#            |___/

# components/PrivacyModal:
privacyModal:
    contactSupport: Contact support
    iAgree: I agree
    body: >
        Mit der Nutzung von Enlivio stimmst Du folgenden Punkten zu:<br />
        <span role="img" aria-label="lock"> 🔒 </span> Bild und Ton der folgenden Therapiesitzung 
        werden sicher verschlüsselt ausschließlich an dein:e Therapeut:in übertragen <br />
        <span role="img" aria-label="lock"> 🏋️ </span> Zur Verdeutlichung von Übungen kann dein:e 
        Therapeut:in Standbilder (Screenshots/Bildschirmfotos) erstellen, kommentieren 
        zum Download zur Verfügung stellen <br />
        <span role="img" aria-label="lock"> 🙅 </span> Du kannst dich jederzeit <b>stumm- oder die Kamera ausschalten</b>. 
        🔏 Bitte beachte unsere Hinweise zum 
        <a rel="noopener noreferrer" href="https://www.enlivio.com/datenschutz" target="_blank">
        Datenschutz</a>.

#  _   _       _   _  __ _           _   _
# | \ | | ___ | |_(_)/ _(_) ___ __ _| |_(_) ___  _ __
# |  \| |/ _ \| __| | |_| |/ __/ _` | __| |/ _ \| '_ \
# | |\  | (_) | |_| |  _| | (_| (_| | |_| | (_) | | | |
# |_| \_|\___/ \__|_|_| |_|\___\__,_|\__|_|\___/|_| |_|
#

notification:
    fcmNewDeviceLoginTitle: Alert! New Device Login.
    fcmNewDeviceLoginBody: Your account has been logged in to another device
    fcmAppointmentCancelTitle: Appointment Cancelled
    fcmAppointmentCancelBody: Your therapist has canceled the appointment at $appointmentDateTime
    fcmAppointmentConfirmTitle: Appointment Confirmed
    fcmAppointmentRejectTitle: Appointment Rejected
    fcmAppointmentRejectBody: Your therapist has rejected the appointment at $appointmentDateTime
    fcmAppointmentConfirmBody: Your therapist has confirmed the appointment at $appointmentDateTime
    fcmAppointmentCreatedTitle: Appointment Created
    fcmAppointmentCreatedBody: Your therapist has scheduled a new meeting at $appointmentDateTime
    fcmAppointmentRemovedTitle: Appointment Cancelled
    fcmAppointmentRemovedBody: Your therapist has cancelled the meeting on $appointmentDateTime
    fcmNewChatMessageTitle: You have a new message
    fcmNewChatMessageBody: Please open the app to view and reply

sendgridTemplates:
    SupportEmail: support@enlivio.com
    BookP_1_Registration: d-305c1da7b6994877b8edb74314360f71
    BookP_2_Confirmation_Offline: d-364ddfdb0c374c6ca5526e970ce23833
    BookP_2_Confirmation_Online: d-55109ee14d5042c98fd3cbaccde78f2d
    BookP_3_Reminder_Offline: d-18f615024c1742bb87afe1910e64563a
    BookP_3_Reminder_Online: d-3bb77e1585674617b0d770407e7657b6
    BookP_5_WaitingList: d-accf851aded44c3aadd8913434c0ccde
    BookP_4_ThankYouMail: d-3dac51175513483ca18f7479cbf3f7bd
    BookP_6_Cancellation: d-0a1dc4fbf9144aebbd5fabb864824746
    BookP_7_Cancellation_ByParticipant: d-cbbb828bc9b44b399b1217fd835fe71a
    BookP_8_Cancellation_OfSubscription: d-07adea67a36943e98fc18a76c9f94d6d
    BookP_9_Reminder_Online_LastMinute: d-bf18a5b5283146baaf877c3f3c842b4f
    BookP_9_Reminder_Offline_LastMinute: d-bf5f0cefcd9d44a38916ee2e217ace03
    BookT_1_NewRegistration: d-f409f50c9cc8486693dd11e56aa365a7
    BookT_1_NewRegistration_WaitingList: d-5fa0c86771024387b44e707fe1c908c2
    BookT_2_Reminder_Hybrid: d-c3efd7420941463bbb5c7b202ffdcf1a
    BookT_2_Reminder_OfflineOnly: d-49a0fd922cbe4cfc8deab2e3ea4efb34
    BookT_2_Reminder_OnlineOnly: d-de8d04b314ba4f6e9c0ea7d4e154f2af
    BookT_3_Cancellation: d-d6d826dbb2934f4c8d04bc475d4e1f35
    BookT_4_CancellationParticipant: d-e24c503ae3044f8d877fd75788bfbe3b
    BookT_5_ThankyouNote: d-0bed657083a14580adb24b8c3d32845e
    MApp_Patient_0_Welcome_Combined: 15
    MApp_Patient_Reset_Password: 18
    APP_Feedback_Email: 19
    Trainingplan_expired_DE: 20
    Therapist_FirstMail: 21
    Patient_MeetingAccepted: 24
    Patient_MeetingCancelled: 26
    Patient_MeetingRejected: 25
    Therapist_NewMeeting: 22
    Therapist_MeetingCancelled: 23
    Patient_NewMeetingByTherapist: 29
    Therapist_Chat_Notification: 35

#  ____       _   _            _
# |  _ \ __ _| |_(_) ___ _ __ | |_
# | |_) / _` | __| |/ _ \ '_ \| __|
# |  __/ (_| | |_| |  __/ | | | |_
# |_|   \__,_|\__|_|\___|_| |_|\__|
#

# components/CreatePatientForm
createPatientForm:
    intro: >
        Create one room entry <strong>per patient</strong>. <br />
        Patients can enter their room anytime with their personal link and will be forwarded to a virtual waiting room until you join.
    firstName: First name
    lastName: Last name
    email: E-Mail address
    seniorMode: Enable Senior-Mode?
    shouldSendInviteEmail: Send invite via Email
    createRoomAndSendEmail: Create room and send Email
    createRoom: Create patient
    patientProfile: "Mobile app profile for patient: activate in?"
    invalidFirstName: Please provide a valid first name.
    invalidLastName: Please provide a valid last name.
    invalidEmail: Please provide a valid email.
    consentPatientHTML: By creating a patient, I acknowledge that the patient is able to exercise according to the <a href="https://www.enlivio.com/intendeduse" target="_blank">intended use definition</a>.
    contraindication:
        contraindicationMsg: Patient has none of these contraindications
        intendedUseMsg: Patient is eligible to be treated according to intended use definition
        title: Intended use and contraindications
        titleIntro: Enlivio is only available for patients who do not show any of the contraindications. Make sure that none of the following indications are present.
        body:
            <h1><strong>Intended Use</strong></h1>
            <p>Please carefully read the intended use<p>
            <p>enlivio enables therapists and physicians to provide teletherapeutic care to their patients
            and offer personalized exercise therapy at home. The enlivio software itself does not make any medical
            or therapeutic decisions. All medical or therapeutic decisions, as well as the decision to use enlivio
            for teletherapeutic care are made by the medical specialist, called “therapist” in the following
            (such as physiotherapists / physician / other occupational therapists in the field of medical-technical services). <br>
            <strong>Important:</strong> The use of enlivio cannot replace a visit to a doctor or therapist.</p>
            <p>Patients with the following characteristics can be treated with enlivio:</p>
            
            <p><strong>General:</strong> Patients must be over 18 years of age. </p>
            
            <p><strong>Medical Requirements:</strong> The use of enlivio is only suitable for patients who are eligible for medical
            exercise therapy. The decision for teletherapeutic care of patients is always up to the therapist.
            Enlivio is certified as a medical product for a) orthopedics and traumatology, b) neurology and c)
            internal medicine. It is important to note that for corresponding contraindications the use of enlivio is not permitted.</p>
            
            <p><strong>Technical requirements:</strong> Patients must be in possession of an internet-enabled
            smartphone or tablet and be able to use it independently. Only devices with an Android operating
            system with version 5.0 or higher, or with an iOS operating system with version 12.0 or higher are
            supported. Regular updates of the software are mandatory in order to enable secure teletherapeutic training.</p>
            <hr>
            <h1><strong>Kontraindikationen</strong></h1>
            <p>The medical indications are split up in three different areas</p>
            <ul>
            <li>- Orthopedic &amp; Traumatology</li>
            <li>- Internal Medicine</li>
            <li>- Neurology</li>
            </ul>
            <p>The descriptions below only provide a range of possible indications that might be addressable
            with the r4P software device. The decision which indication is treated with help of the r4P Software
            is always made by the physician who prescribes physiotherapy. The app does not make medical recommendations,
            diagnoses or other medical or therapeutic decisions as to whether and to what extent a patient should be treated.</p>
            <p>The enlivio app <strong>cannot be used</strong> for certain contraindications (regardless of the medical field).
            The contraindications are shown in the table below</p>
            <table class="table table-bordered">
            <tbody>
            <tr>
            <td class="confluenceTd">
            <p><strong>Medical area</strong></p>
            </td>
            <td class="confluenceTd">
            <p><strong>Contra Indication</strong></p>
            </td>
            </tr>
            <tr>
            <td class="confluenceTd">
            <p>Orthopedics &amp; Traumatology</p>
            </td>
            <td class="confluenceTd">
            <p>All kinds of acute syndromes/injuries/infections or aggravations of chronic diseases</p>
            <p>Medical conditions that need acute surgical or other medical intervention</p>
            <p>Conditions with acutely increased risk of injury or death</p>
            <p>Systemic illnesses/conditions that cannot be addressed by physiotherapeutic intervention</p>
            <p>Systemic illnesses/conditions that would lead to an increased risk of injury during training
            (e.g. vertigo, recurrent falls...) or prevent the patient from exercising properly / by themselves
            (e.g. immobility, substantial cognitive deficits)</p>
            <p>Exercising while in (too much) pain, for example without customized pain medication</p>
            </td>
            </tr>
            <tr>
            <td class="confluenceTd">
            <p>Neurology</p>
            </td>
            <td class="confluenceTd">
            <p>Neglect</p>
            <p>Patients with inacceptable risk of falling</p>
            <p>Inacceptable cognitive limitations/ cognitive impairment</p>
            <p>Neurodegenerative diseases or acute conditions that hinder patients from performing tasks independently (e.g. immobility)</p>
            <p>Acute Infections or aggravations of chronic diseases that need medical treatment</p>
            <p>Conditions where Patient is unconscious, sleeping or otherwise restricted in their attention</p>
            <p>Conditions that require hospitalization and/or medical surveillance</p>
            <p>Systemic Illnesses/conditions that cannot be addressed by physiotherapeutic intervention</p>
            <p>Medical conditions that need acute surgical or other medical intervention</p>
            </td>
            </tr>
            <tr>
            <td class="confluenceTd">
            <p>Internal Medicine</p>
            </td>
            <td class="confluenceTd">
            <p>Patients with physical or psychological/mental impairment who are not sufficiently resilient and/or cannot be
            mobilized and therefore cannot actively use the measures of tele-rehabilitation</p>
            <p>Acute danger to self or others</p>
            <p>Acute or decompensated disease states that preclude the ability to rehabilitate (e.g. decompensated heart failure,
            severe valvular insufficiency, acute pulmonary embolism (ACS))</p>
            <p>Acute exacerbation of chronic obstructive pulmonary disease or acute exacerbations of chronic bronchitis (AECB), as
            well as a sudden worsening of chronic obstructive pulmonary disease (COPD) symptoms including shortness of breath</p>
            <p>Acute asthma exacerbation or progressive worsening of asthma symptoms, including breathlessness, wheeze, cough and chest tightness</p>
            <p>Medical conditions that need acute surgical or other medical intervention</p>
            <p>Acute/florid infectious diseases</p>
            <p>Inadequate diagnostic workup</p>
            <p>NYHA IV heart failure</p>
            <p>Higher-grade obstruction of the left ventricular outflow tract (aortic stenosis, hypertrophic-obstructive (CMP))</p>
            </td>
            </tr>
            </tbody>
            </table>
            <p>The use of r4P Software cannot replace a traditional visit to a doctor or therapist. For a final and comprehensive treatment,
            the visit of a doctor and therapist on-site or, in urgent cases, a visit in a hospital is required. Special professional
            regulations and restrictions apply to medical care via the internet (i.e. written confirmation by patient for allowance of
            data transfer via the internet required). </p>
        save: Accept
        mouseOver: Please accept the intended use and the exclusion of contraindications

# components/Patienten
patients:
    createNewGroupRoom: Create new group room
    createInstantRoom: One-time room
    enterRoom: Join room
    groupRooms: Group-Rooms
    editGroupRoom: Edit Group-room
    createGroupRoom: Create Group-room
    deleteGroupRoom: Delete Group-room
    deleteGroupRoomQuestion: Do you really want to delete "{{id}} {{name}}"?
    therapistBadge: TEST-ACCOUNT
    heading: Patients
    introText:
        <h1>Patient Overview</h1>
        <p>Find below a list of all patients you have added to your account</p>
        <p>Click on any patient to adjust training plans and schedule meetings.</p>
    createNewP2PRoom: Create new patient room
    createPatient: Create patient
    editPatientRoom: Edit patient room
    createPatientRoom: Create patient room
    deletePatientRoom: Delete patient room
    deletePatientRoomQuestion: Do you really want to delete {{firstName}} {{lastName}}?
    noPatients: You don’t have any patients yet.
    archivePatientTitle: Archive patient
    archivePatientBody: This patient will not be accessible anymore.
    daysRemainingLabel: Days
    searchLabel: Search
    noPatientFound: No Patient Found
    tableHeader:
        name: Name
        program: Program
        nextTherapy: Next Therapy
        trainingPlan: Training Plan

#   ___                  _   _                         _
#  / _ \ _   _  ___  ___| |_(_) ___  _ __  _ __   __ _(_)_ __ ___
# | | | | | | |/ _ \/ __| __| |/ _ \| '_ \| '_ \ / _` | | '__/ _ \
# | |_| | |_| |  __/\__ \ |_| | (_) | | | | | | | (_| | | | |  __/
#  \__\_\__,_|\___||___/\__|_|\___/|_| |_|_| |_|\__,_|_|_|  \___|
#

#components/Proms
proms:
    heading: Questionnaire
    introText: >
        <h1>Questionnaire</h1>
        <p>Configure which questions you want your patient to asnwer on a regular basis. Each question will be answered on a scale of 1 to 10. You will be able to see your patients answers.</p>
    createProm: Fragebogen anlegen
    editProm: Fragebogen bearbeiten
    deleteProm: Fragebogen löschen
    deletePromQuestion: Willst du den Fragebogen wirklich löschen?
    draftPromQuestion: Willst du den Fragebogen wirklich auf "Entwurf" setzen?
    publishPromQuestion: Willst du den Fragebogen wirklich veröffentlichen?
    saveButton: Save Changes
    saveText: Saved!
    every training: every training
    once a week: once a week

#components/AnswerAndActivity
answerAndActivity:
    warningText: Please consider that the below data represents subjective self-assessments of the patient. Always talk to the patient in a therapy session before making further treatment decisions.
    answerTitle: Questionnaire answers
    activityTitle: Activity
    AbortedText:
        NOTFIT: I don’t feel fit
        NOTIME: I have no time
        NOANSWER: I don’t want to answer
    noActivity: The patient has not done anything yet.
    noTrainingPlanActivity: The patient has not done anything yet.
    noAnswer: The patient has not answered any questions yet.
    effortLow: Not at all
    effortHigh: Very
    breathlessnessLow: Not at all
    breathlessnessHigh: Very
    progressLow: Not at all
    progressHigh: Very
    restrictionLow: Not at all
    restrictionHigh: Very
    painLow: Not at all
    painHigh: Very
    SKIPPED: Skipped
    AbortedLabel: Abort Reason
    GeneralFeedback: General Feedback
    ReasonToAbort: Reason to abort
    ExerciseStatusABORTED: ABORTED
    ExerciseStatusDONE: DONE
    ExerciseStatusSKIPPED: SKIPPED
    ExerciseStatusDONEWITHSKIPS: DONE WITH SKIPS
    ExerciseLabel: Exercise
    TrainingCompleted: trainings completed
    trainingPlanFrom: Training Plan From {startDate} - {endDate}
    viewTrainingPlanBtn: View Training Plan
    viewTrainingPlanModal:
        workoutsPerWeek: per week
        workoutPause: seconds pause
    WeekText: Week
    CurrentText: current
    Months: January, February, March, April, May, June, July, August, September, October, November, December
    ShortMonths: Jan, Feb, Mar, Apr, May, Jun, Jul, Aug, Sep, Oct, Nov, Dec

# components/CreateUpdatePromForm
createUpdatePromForm:
    questionnaire: Fragebogen
    triggers: Auslöser
    triggerType: Auslöser-Typ
    triggerExercise: Übung
    triggerWorkout: Workout
    triggerTypeEveryday: Täglich
    triggerTypeEveryWeek: Wöchentlich
    triggerTypeEverySecondWeek: Jede zweite Woche
    triggerTypeAfterExercise: Nach Übung
    triggerTypeBeforeExercise: Vor Übung
    triggerTypeAfterWorkoutWeek: Nach Workout
    triggerTypeBeforeWorkoutWeek: Vor Workout
    triggerWorkoutNotAvailable: Nicht verfügbar
    addTrigger: Auslöser hinzufügen
    saveProm: Speichern
    savePromSuccess: Erfolgreich gespeichert
    savePromError: Etwas ist schief gelaufen

#components/Questionnaire
questionnaire:
    heading: Questionnaires
    introText:
        <h1>questionnaire - overview</h1>
        <p>Here you can see all the questionnaires you have created for the patient.</p>
        <p>Click on a questionnaire to edit it. The questionnaire will only be visible to the patient once you have changed the status to 'Publish'.</p>
    createQuestionnaire: Create questionnaire
    editQuestionnaire: Edit questionnaire
    deleteQuestionnaire: Delete questionnaire
    deleteQuestionnaireQuestion: Do you really want to delete the questionnaire?

#  ____
# |  _ \ ___   ___  _ __ ___
# | |_) / _ \ / _ \| '_ ` _ \
# |  _ < (_) | (_) | | | | | |
# |_| \_\___/ \___/|_| |_| |_|
#

pin:
    enterRoom: Enter room
    enterPinCode: PIN-Code
    error-required: Please enter the PIN code, to join the room.
    error-participated: Your PIN code is already used by another participant.
    error-cancelled: Your participation in this event has been cancelled.
    error-wrong: The PIN code is wrong.
    error-wrong-trainer: You are not allowed to join this session as a trainer.

room:
    waiting:
        welcome: Welcome to enlivio!
        title1: Please press the button
        title2: to take part in the video call!
        patientText: A moment please! You will be connected as soon as your host joins the meeting
        hostText: A moment please! You will be connected as soon as your participant joins the meeting
        isConnecting: You will be connected shortly ...
    screenshot:
        not-possible: Your patient's camera is deactivated. You can only create screenshots if the camera is activated.
    controls:
        cameraSwitch:
            changeActiveCamera: Choose active camera.
            selectCameraFromList: Choose a camera from the list.
            changeCamera: Change camera
    endCall:
        confirmButton: Leave room
        title: Are you sure?
        body: Room will be closed if you go back. Needs to be reopened.

#  ____  _                        _
# / ___|| |__   __ _ _ __ ___  __| |
# \___ \| '_ \ / _` | '__/ _ \/ _` |
#  ___) | | | | (_| | | |  __/ (_| |
# |____/|_| |_|\__,_|_|  \___|\__,_|
#

# components/Uploader
uploader:
    dropZoneText: Place image here or
    dropZoneButtonLabel: Select
    downloadButtonLabel: Download

# components/DeleteFileModal
deleteFileModal:
    title: Delete image
    question: Do you want to delete this image?

# components/RechargeCredits
rechargeCredits:
    labels:
        email: Email
        creditHours: Credits in Stunden
    buttons:
        addCredits: Credits hinzufügen

# components/Header
header:
    eventsNav: Groups
    imagesNav: Images
    contactNav: Contact
    adminNav: Admin
    accountNav: Account
    myAccountNav: My Account
    logoutNav: Logout
    roomsNav: Rooms
    signinNav: Sign in
    contactHeader: Contact
    therapiesNav: Therapies
    patientsNav: Patients
    messages: Messages
    contactModalBody: You can reach out to us at <a rel="noopener noreferrer" href="mailto:info@enlivio.com" target="_blank">info@enlivio.com</a>.
    appointments: Appointments

# components/Footer
footer:
    <span class="float-left center-xs">© Enlivio 2022</span> <span class="float-right">
    <a rel="noopener noreferrer" href="mailto:info@enlivio.com" target="_blank"> info@enlivio.com </a> |
    <a href="https://www.enlivio.com/hilfe/" target="_blank"> Help </a> |
    <a href="/about"> About </a> |
    <a href="https://www.enlivio.com/impressum/" target="_blank"> Imprint </a> |
    <a href="https://www.enlivio.com/wp-content/uploads/2021/11/AGB_Enlivio_B2B_v3_inclAVV_Physio.pdf" target="_blank"> Conditions </a> |
    <a href="https://www.enlivio.com/wp-content/uploads/2021/11/20211027-heyData_Datenschutzerkla%CC%88rung-Website_DE_room4-Softwareentwicklung-GmbH_https___app.enlivio.com-1.pdf" target="_blank"> Privacy </a>
    </span>

# containers/404
notFound:
    subTitle: Something went wrong
    body: The page you are looking for was moved, removed or may never have existed.
    buttonText: Back to home

# __        __         _               _
# \ \      / /__  _ __| | _____  _   _| |_
#  \ \ /\ / / _ \| '__| |/ / _ \| | | | __|
#   \ V  V / (_) | |  |   < (_) | |_| | |_
#    \_/\_/ \___/|_|  |_|\_\___/ \__,_|\__|
#

#containers/Workouts/WorkoutsContainer
workouts:
    introText: >
        <h1>Training plan</h1>
        <p>A training plan allows your patient to exercise alone at home using the app.</p>
    createTraining: Create training plan
    editTraining: Edit training plan
    workoutCreateFCMTitle: New Training Plan
    workoutCreateFCMBody: Your therapist has published a new training plan for you
    workoutUnpublishedFCMTitle: Unpublished Plan
    workoutUnpublishedFCMBody: Your therapist has unpublished training plan for you

#components/workouts/Workout
workout:
    labels:
        title: 'Titel:'
        calendarWeek: 'Kalenderwoche:'
        noteTherapist: 'Anmerkung:'
        exerciseTitle: 'Titel:'
        exerciseType: 'Typ:'
        knee: Knie
        shoulder: Schulter
        hip: Hüfte
        back: Rücken
        neck: Nacken
        dynamicCondition: 'Dynamisch:'
        breakBetweenSets: 'Pause zwischen Sätze (Sek):'
        exerciseNoteTherapist: 'Hinweise:'
        exerciseSets: 'Sätze:'
        exerciseSetRepetitions: Wdh

#components/trainingPlans/TrainingPlanDetails
trainingPlan:
    unpublish:
        title: Unpublish training plan
        body: Your patient will not be able to do their exercises until you publish the training plan again.
        button: Unpublish
    trainingPlanFor: Training Plan for
    trainingPlanGenericError: There are some errors on below listed trainings. Please check all exercise and training settings.
    tabLable: Tab
    status:
        UNPUBLISHED: Unpublished
        PUBLISHED: Published
        DRAFT: Unpublished
    publishUntil: Published until
    newTabTraning: Training
    saveAndPublish: Save & Publish
    saveAsDraft: Save draft
    saveAndPublishModal:
        body: The training plan will be published for the specified timeframe
        label: Valid until
        isGlobalLabel: Save As Global Template?
        templateLabel: Category
        templatePlaceHolder: e.g Back Pain
        templateHelpText: The category name will be used so that you can better find your templates again.
    validation:
        date: Invalid date
        greaterDate: Cannot select date greater than 4 weeks
        pastDate: Cannot select past date
        templateName: Category name is required
        futureDate: Date more than 2 month can not be selected
        invalidDate: Invalid Date! correct date format is DD-MM-YYYY
    unSavedWarning: All unsaved changes will be lost. Continue?

#components/trainingPlans/TrainingPlanForm
trainingPlanForm:
    title: Trainings
    addTraining: Add training
    saveAsTemplateTitle: Save as training template
    saveAsTemplate: Save as template
    loadTemplate: Load template
    templateModalTitle: Load Template
    templateModalButton: Add Selected Template
    templateModalError: Max 4 trainings can be added to a training plan. Please delete some before adding.
    templateModalNoTemplate: Template not found
    templateModalConfirm: Confirm?
    perWeek: per week
    trainingName: Training name
    trainingNameValidation: Please provide a valid name.
    workoutsPerWeek: Workouts per week
    workoutsPerWeekValidation: Only values between 1 and 7 accepted.
    workoutPause: Pause between exercises
    workoutPauseValidation: Please add at least 10 sec. of pause.
    deleteTraining: Delete training
    deleteTrainingBody: Are you sure you want to delete training?
    exercise: Exercises
    noExercise: No exercises yet.
    pauseGroup: seconds
    yourTemplateText: Your Template
    globalTemplateText: Global Template
    deleteTemplateTitle: Delete template
    deleteTemplateBody: Are you sure you want to delete template {templateName}?

#components/trainingPlans/AddExerciseModal
exerciseModal:
    title: Add exercise
    addStaticExercise: Custom exercise
    addDynamicExercise: Custom dynamic exercise
    addEnduranceExercise: Endurance exercise
    filterText: Filters
    filterClearText: Clear Filter
    selectionDone: Add selected exercises
    customExercise:
        enName: Custom Exercise
        deName: Benutzerdefinierte Übung
        enDescription: Custom Exercise
        deDescription: Benutzerdefinierte Übung
    enduranceExercise:
        enName: Name of the Endurance Exercise
        deName: Name der Ausdauerübung
        enDescription: Description of the Endurance Exercise
        deDescription: Beschreibung der Ausdauerübung

#components/trainingPlans/AddExerciseModal
exerciseCard:
    deleteExercise:
        title: Delete exercise
        body: Are you sure you want to delete this exercise?
    validation:
        name: Please add valid name.
        description: Please add valid description.
        greaterSets: High set count.
        lowerSets: Low set count.
        greaterRepetition: High repetition count.
        lowerRepetition: Low repetition count.
        greaterTime: High duration.
        lowerTime: Low duration.
        invlaidValue: Invalid value.
    form:
        name: Exercise Name
        description: Exercise Description
        skipPause: Skip break afterwards
        skipPauseDescription: If enabled, the patient will not need to take a break after a set of this exercise. Use this for warmup exercises or other exercises that don’t need recovery time.
        sets: Sets
        repetition: Repetition
        time: Time
        timeGroup: sec
        customDescripton: Custom Description
        amount: Amount
        dropdown:
            sec: Sec
            min: Min
            reps: Reps